module.exports = "/images/unified-user-experience.jpg?3fd31386c298e005bf8ce6bdfde5a45d";